import { FIELD_TYPES } from '../../components/FormField'

export const FIELDS = [
  { label: 'Name', name: 'name', type: FIELD_TYPES.TEXT, defaultValue: '' },
  {
    label: 'Icon',
    name: 'icon',
    type: FIELD_TYPES.AI_ICONS,
    defaultValue: '911HangUp.png',
  },
  { label: 'Layer Url', name: 'url', type: FIELD_TYPES.TEXT, defaultValue: '' },
  {
    label: 'Token Service Url',
    name: 'tokenServiceUrl',
    type: FIELD_TYPES.TEXT,
    defaultValue: '',
  },
  {
    label: 'Username',
    name: 'username',
    type: FIELD_TYPES.TEXT,
    defaultValue: '',
  },
  {
    label: 'Password',
    name: 'password',
    type: FIELD_TYPES.TEXT,
    defaultValue: '',
  },
  {
    label: 'Refresh Interval (0 for never)',
    name: 'refreshInterval',
    type: FIELD_TYPES.NUMBER,
    defaultValue: 0,
  },
  {
    label: 'Geometry Type',
    name: 'geometryType',
    type: FIELD_TYPES.SELECT,
    options: [
      { label: 'Point', value: 'point' },
      { label: 'Polygon', value: 'polygon' },
    ],
    defaultValue: 'point',
  },
  {
    label: 'Where Clause',
    name: 'whereClause',
    type: FIELD_TYPES.TEXT,
    defaultValue: '',
  },
  { label: 'Fields', name: 'fields', type: FIELD_TYPES.TEXT, defaultValue: '' },
  {
    label: 'Id Field',
    name: 'idField',
    type: FIELD_TYPES.TEXT,
    defaultValue: '',
  },
  {
    label: 'Label Field',
    name: 'labelField',
    type: FIELD_TYPES.TEXT,
    defaultValue: '',
  },
  {
    label: 'Popup Template',
    name: 'popupTemplate',
    type: FIELD_TYPES.TEXT_AREA,
    rows: 10,
    defaultValue: '',
  },
]
